import React, { ChangeEvent } from "react";
import { useAnalytics } from "utils/analytics/AnalyticsContext";
import { ActionType } from "utils/analytics/analyticsConstants";
import styled from "styled-components/macro";
import Checkbox from "ui/Checkbox";
import Form from "ui/Form";
import Typography from "ui/Typography";
import Link from "ui/Link";
import { theme } from "ui/theme";

const $Wrapper = styled(Form.Group)`
  display: flex;
  align-items: flex-start;
  margin-bottom: 0;
`;

const $Checkbox = styled(Checkbox)`
  margin-top: -0.25rem;
`;

const $TextWrapper = styled(Typography).attrs({
  size: "tooltip",
  color: "ColorSpace500",
})`
  font-size: ${theme.FontSizeFinePrint};
  text-align: left;
  padding-left: 0.5rem;
`;

interface TosCheckboxProps {
  onChange: (checked: boolean) => void;
  checked?: boolean;
}

export default function TosCheckbox(props: TosCheckboxProps) {
  const { trackEvent } = useAnalytics("TeacherSignup");

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    trackEvent({
      eventName: "clicked_accept_tos_box",
      eventType: ActionType.CLICK,
    });
    props.onChange(e.target.checked);
  };

  return (
    <$Wrapper>
      <$Checkbox
        checked={props.checked}
        onChange={onChange}
        name="acceptedTos"
        id="accepting-tos-checkbox"
        aria-required
      />
      <Form.Label htmlFor="accepting-tos-checkbox">
        <$TextWrapper>
          I agree to the{" "}
          <Link
            href="/user-agreement"
            opensInNewTab
            analyticsName="clicked_user_agreement_link"
            rel="noopener noreferrer"
          >
            Along User Agreement
          </Link>
          ,{" "}
          <Link
            href="/privacy-policy"
            opensInNewTab
            analyticsName="clicked_privacy_policy_link"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </Link>
          , and{" "}
          <Link
            href="/code-of-conduct"
            opensInNewTab
            analyticsName="clicked_code_of_conduct_link"
            rel="noopener noreferrer"
          >
            Code of Conduct
          </Link>
          , and will use Along only for educational purposes. I verify that I am
          authorized to accept these terms on behalf of my school, and in that
          capacity, I grant Along permission to handle student personal
          information.
        </$TextWrapper>
      </Form.Label>
    </$Wrapper>
  );
}
